import { CRUDEntity } from "../abstracts/CRUDEntity";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";

export class Subscription extends CRUDEntity {
    constructor(id=null){
        super();
        this.entityClass = 'subscription';
        this.urlRoot = '/subscription';
        this.sectionRootUrl = '/subscription';
        this.id = id;

        Object.assign(Subscription.prototype, EntityModalForm);
    }
}
